module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_miyakojima-478c426ca0f916ea3c95bedf529d98cf.webp";